'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @desc 帮助类 
 */
// 是否是线上
var productionTip = process.env.NODE_ENV === 'production';

exports.default = {
    reverseParams: function reverseParams(params) {
        var arr = [];
        (0, _keys2.default)(params).forEach(function (key) {
            if (/^\$/.test(key)) {
                // 如果key是$开头，则不会使用
                return;
            }
            if (params[key] === undefined) {
                if (productionTip) {
                    return delete params[key];
                } else {
                    console.error('Net Work Error: ' + key + ' 不允许为undefined'); // eslint-disable-line
                }
            }
            arr.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
        });
        return arr.join('&');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/http-request/dist/utils/index.js
// module id = ACDA
// module chunks = 8